import { PaginatedWithSummary } from '@orderna/admin-panel/src/types/pagination';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import moment from 'moment';
import { DailyTransactions } from '../../../../model/daily-transactions';
import { QueryOptionsMapper } from '../../../mapper/query-options.mapper';

export class DailyTransactionsApiMapper {
  static fromDto(dto: any): PaginatedWithSummary<DailyTransactions> {
    const { data = [], meta, summary } = dto ?? {};

    return {
      data: data.map((o: any, index: number): DailyTransactions => {
        const date = moment(o.date, 'YYYY-MM-DD', true).isValid() ? o.date : new Date();
        return {
          id: index,
          date: moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD'),
          transactionsCount: o.transactionsCount ?? 0,
          revenue: o.revenue ?? 0,
          costOfGoods: o.costOfGoods ?? 0,
          grossProfit: o.grossProfit ?? 0,
          serviceFees: o.serviceFees ?? 0,
          tipsCount: o.tipsCount ?? 0,
          tipsAmount: o.tipsAmount ?? 0,
          refundsCount: o.refundsCount ?? 0,
          refundsAmount: o.refundsAmount ?? 0,
        };
      }),
      summary: {
        transactionsCount: summary.transactionsCount ?? 0,
        revenue: summary.revenue ?? 0,
        costOfGoods: summary.costOfGoods ?? 0,
        grossProfit: summary.grossProfit ?? 0,
        serviceFees: summary.serviceFees ?? 0,
        tipsCount: summary.tipsCount ?? 0,
        tipsAmount: summary.tipsAmount ?? 0,
        refundsCount: summary.refundsCount ?? 0,
        refundsAmount: summary.refundsAmount ?? 0,
      },
      pagination: {
        page: meta.page,
        totalPages: Math.ceil(meta.total / meta.size),
        total: meta.total,
        size: meta.size,
      },
    };
  }

  static toFilterDto(options: QueryOptions<DailyTransactions>) {
    return {
      ...QueryOptionsMapper.toStoreFilterDto(options),
      ...QueryOptionsMapper.toDynamicPeriodDto(options),
      ...QueryOptionsMapper.toPaginationDto(options),
      ...QueryOptionsMapper.toSortOrderDto(options),
      ...this.toSortByDto(options),
    };
  }

  private static toSortByDto(options: QueryOptions<DailyTransactions>) {
    const field = options.sort?.field;
    if (!field) return null;

    return { sortBy: this.toSortBy(field) };
  }

  private static toSortBy(field: string) {
    switch (field) {
      case 'date':
        return 'date';
      case 'transactionsCount':
        return 'transactions_count';
      case 'revenue':
        return 'revenue';
      case 'costOfGoods':
        return 'cost_of_goods';
      case 'grossProfit':
        return 'gross_profit';
      case 'serviceFees':
        return 'service_fees';
      case 'tipsCount':
        return 'tips_count';
      case 'tipsAmount':
        return 'tips_amount';
      case 'refundsCount':
        return 'refunds_count';
      case 'refundsAmount':
        return 'refunds_amount';
      default:
        throw new Error(`Field does not exist: ${field}`);
    }
  }
}
